module.exports = __webpack_public_path__ + "images/0c06aca14bb118aa826e3d591debabd6a4fa6003f207248438353b43912a7bb5.svg";